export enum SessionKeys {
  AUTH_TOKEN = 'authToken',
  ORIGIN = 'origin',
  SESSION_ID = 'sessionId',
  SIMULATOR_STATE = 'simulatorState',
  USER_CONTEXT = 'userContext',
}

const save = (key: string, value: string | number): void => {
  if (value) window.sessionStorage.setItem(key, value as string);
};
const load = (key: string): Nullable<string> =>
  window.sessionStorage.getItem(key);
const clear = (key: string): void => {
  window.sessionStorage.removeItem(key);
};

export const sessionGet = load;
export const sessionSet = save;
export const sessionClear = clear;
